module.exports = __webpack_public_path__ + "static/wef-resource-tile-469c83278690f77e9fd229bf3988ca3a.jpeg";